import useMediaQuery from '@mui/material/useMediaQuery';

function useMobile() {
  return useMediaQuery((theme) => theme.breakpoints.down('sm'));
}

export default useMobile;
